import React, { createContext, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

const DDPWealthJourneyEntryListContext = createContext({
  selectedEntry: null,
  setSelectedEntry: () => {},
  selectedYear: null,
  setSelectedYear: () => {}
})

export const useDDPWealthJourneyEntryListState = () => {
  return useContext(DDPWealthJourneyEntryListContext)
}

function DDPWealthJourneyEntryListStateProvider ({
  children,
  selectedEntry: controlledEntry,
  setSelectedEntry: controlledSetEntry,
  selectedYear: controlledYear,
  setSelectedYear: controlledSetYear
}) {
  const [internalEntry, internalSetEntry] = useState(controlledEntry)
  const [internalYear, internalSetYear] = useState(controlledYear)

  // Use controlled values if provided, otherwise use internal
  const selectedEntry = controlledEntry !== undefined ? controlledEntry : internalEntry
  const selectedYear = controlledYear !== undefined ? controlledYear : internalYear
  const setSelectedEntry = controlledSetEntry || internalSetEntry
  const setSelectedYear = controlledSetYear || internalSetYear

  const contextValue = useMemo(() => ({
    selectedEntry,
    setSelectedEntry,
    selectedYear,
    setSelectedYear
  }), [selectedEntry, selectedYear, setSelectedEntry, setSelectedYear])

  return (
    <DDPWealthJourneyEntryListContext.Provider value={contextValue}>
      {children}
    </DDPWealthJourneyEntryListContext.Provider>
  )
}

DDPWealthJourneyEntryListStateProvider.propTypes = {
  children: PropTypes.node,
  selectedEntry: PropTypes.object,
  setSelectedEntry: PropTypes.func,
  selectedYear: PropTypes.number,
  setSelectedYear: PropTypes.func
}

export default DDPWealthJourneyEntryListStateProvider
